export default __webpack_public_path__ + "static/media/login-brand-image-2-white.e35c7863.jpg";